import { render, staticRenderFns } from "./goodsListByIntegral.vue?vue&type=template&id=304553ff&scoped=true"
import script from "./goodsListByIntegral.vue?vue&type=script&lang=js"
export * from "./goodsListByIntegral.vue?vue&type=script&lang=js"
import style0 from "./goodsListByIntegral.vue?vue&type=style&index=0&id=304553ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304553ff",
  null
  
)

export default component.exports